import { Mail, MapPin, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-fairway text-cream">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <p className="eyebrow mb-4 text-sun">Desde 2012</p>
            <p className="font-serif text-3xl leading-tight">
              Asociación Nacional de Golf Adaptado A.C.
            </p>
            <p className="mt-4 max-w-md text-cream/70 leading-relaxed">
              El golf como herramienta de rehabilitación física y psicológica.
              Clases gratuitas en Xochimilco para personas con discapacidad.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.facebook.com/AsociacionNacionalDeGolfAdaptadoAc"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-cream/20 px-4 py-2 text-sm text-cream/80 transition-colors hover:border-brass hover:text-brass"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/asociaciongolfadaptadomexico"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-cream/20 px-4 py-2 text-sm text-cream/80 transition-colors hover:border-brass hover:text-brass"
              >
                Instagram
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-semibold uppercase tracking-eyebrow text-sun">
              Explorar
            </h2>
            <ul className="mt-4 space-y-3 text-cream/75">
              {[
                { name: 'Inicio', path: '/' },
                { name: 'Historia', path: '/history' },
                { name: 'Comunidad', path: '/community' },
                { name: 'Golf', path: '/golf' },
                { name: 'Blog', path: '/blog' },
                { name: 'Acerca de', path: '/about' },
                { name: 'Contacto', path: '/contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="hover:text-cream">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold uppercase tracking-eyebrow text-sun">
              Visítanos
            </h2>
            <ul className="mt-4 space-y-4 text-cream/75">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brass" aria-hidden="true" />
                <span>Centro Deportivo Xochimilco<br />Francisco Goitia s/n</span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brass" aria-hidden="true" />
                <a href="tel:+525523785783" className="hover:text-cream">+52 55 2378 5783</a>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brass" aria-hidden="true" />
                <a href="mailto:alejandroflorero4@gmail.com" className="hover:text-cream">alejandroflorero4@gmail.com</a>
              </li>
            </ul>
            <p className="mt-6 text-sm text-cream/60">
              Martes y jueves · 9:30 – 13:00
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-cream/10 pt-8 text-sm text-cream/50 sm:flex-row sm:justify-between">
          <p>© {new Date().getFullYear()} Asociación Nacional de Golf Adaptado A.C.</p>
          <p>
            Sitio por{' '}
            <a
              href="https://www.ponchobt.dev/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cream/80 underline-offset-4 hover:text-brass hover:underline"
            >
              PonchoBT.Dev
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
